import { render, staticRenderFns } from "./OnboardingAvatarPlaceholder.vue?vue&type=template&id=5e08d322"
import script from "./OnboardingAvatarPlaceholder.vue?vue&type=script&lang=js"
export * from "./OnboardingAvatarPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports